export enum FileStatus {
  UPLOAD_CONFIRMED = 'UPLOAD_CONFIRMED',
  UPLOAD_REQUESTED = 'UPLOAD_REQUESTED',
}
